"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_helpers_1 = require("../util/dom-helpers");
var _1 = require("../util/_");
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var warning_1 = require("../util/warning");
var overlay_1 = require("./overlay");
var create_chained_function_1 = require("../util/create-chained-function");
var events = require("../util/dom-helpers/events");
/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
    if (Array.isArray(of)) {
        return of.indexOf(one) >= 0;
    }
    return one === of;
}
var OverlayTrigger = /** @class */ (function (_super) {
    __extends(OverlayTrigger, _super);
    function OverlayTrigger(props) {
        var _this = _super.call(this, props) || this;
        _this.handleWindowResize = function () {
            if (_this.props.hideOnWindowResize) {
                _this.hide();
            }
        };
        _this.show = function () {
            _this.setState({
                isOverlayShown: true
            }, function () {
                if (_this.props.onToggle) {
                    _this.props.onToggle(!!_this.state.isOverlayShown);
                }
            });
        };
        _this.hide = function () {
            _this.setState({
                isOverlayShown: false
            }, function () {
                if (_this.props.onToggle) {
                    _this.props.onToggle(!!_this.state.isOverlayShown);
                }
            });
        };
        _this.toggle = function () {
            if (_this.state.isOverlayShown) {
                _this.hide();
            }
            else {
                _this.show();
            }
        };
        _this.getOverlayTarget = function () {
            return ReactDOM.findDOMNode(_this);
        };
        _this.handleDelayedShow = function () {
            if (_this._hoverHideDelay != null) {
                clearTimeout(_this._hoverHideDelay);
                _this._hoverHideDelay = undefined;
                return;
            }
            if (_this.state.isOverlayShown || _this._hoverShowDelay != null) {
                return;
            }
            var delay = _this.props.delayShow != null ?
                _this.props.delayShow : _this.props.delay;
            if (!delay) {
                _this.show();
                return;
            }
            _this._hoverShowDelay = window.setTimeout(function () {
                _this._hoverShowDelay = undefined;
                _this.show();
            }, delay);
        };
        _this.handleDelayedHide = function () {
            if (_this._hoverShowDelay != null) {
                clearTimeout(_this._hoverShowDelay);
                _this._hoverShowDelay = undefined;
                return;
            }
            if (!_this.state.isOverlayShown || _this._hoverHideDelay != null) {
                return;
            }
            var delay = _this.props.delayHide != null ?
                _this.props.delayHide : _this.props.delay;
            if (!delay) {
                _this.hide();
                return;
            }
            _this._hoverHideDelay = window.setTimeout(function () {
                _this._hoverHideDelay = undefined;
                _this.hide();
            }, delay);
        };
        // Simple implementation of mouseEnter and mouseLeave.
        // React's built version is broken: https://github.com/facebook/react/issues/4251
        // for cases when the trigger is disabled and mouseOut/Over can cause flicker moving
        // from one child element to another.
        _this.handleMouseOverOut = function (handler, e) {
            var target = e.currentTarget;
            var related = e.relatedTarget || e.nativeEvent.toElement;
            if (!related || related !== target && !dom_helpers_1.contains(target, related)) {
                handler(e);
            }
        };
        _this.state = {
            isOverlayShown: props.defaultOverlayShown
        };
        _this.handleMouseOver = _this.handleMouseOverOut.bind(null, _this.handleDelayedShow);
        _this.handleMouseOut = _this.handleMouseOverOut.bind(null, _this.handleDelayedHide);
        return _this;
    }
    OverlayTrigger.prototype.componentDidMount = function () {
        this._mountNode = document.createElement('div');
        this.renderOverlay();
        events.on(window, 'resize', this.handleWindowResize);
    };
    OverlayTrigger.prototype.componentDidUpdate = function () {
        if (this._mountNode) {
            this.renderOverlay();
        }
    };
    OverlayTrigger.prototype.componentWillReceiveProps = function (nextProps) {
        var overlayShown = nextProps.defaultOverlayShown !== undefined ? nextProps.defaultOverlayShown : this.state.isOverlayShown;
        if (overlayShown != this.state.isOverlayShown) {
            this.setState({ isOverlayShown: nextProps.defaultOverlayShown });
        }
    };
    OverlayTrigger.prototype.componentWillUnmount = function () {
        ReactDOM.unmountComponentAtNode(this._mountNode);
        this._mountNode = undefined;
        clearTimeout(this._hoverShowDelay);
        clearTimeout(this._hoverHideDelay);
        events.off(window, 'resize', this.handleWindowResize);
    };
    OverlayTrigger.prototype.getOverlay = function () {
        var overlayProps = Object.assign({}, _1.pick(this.props, Object.keys(overlay_1.Overlay.propTypes)), {
            show: this.state.isOverlayShown,
            onHide: this.hide,
            target: this.getOverlayTarget,
            onExit: this.props.onExit,
            onExiting: this.props.onExiting,
            onExited: this.props.onExited,
            onEnter: this.props.onEnter,
            onEntering: this.props.onEntering,
            onEntered: this.props.onEntered,
            placement: this.props.placement,
            container: this.props.container
        });
        var overlay = React.cloneElement(this.props.overlay, {
            placement: overlayProps.placement,
            container: overlayProps.container
        });
        return (React.createElement(overlay_1.Overlay, __assign({}, overlayProps), overlay));
    };
    OverlayTrigger.prototype.renderOverlay = function () {
        ReactDOM.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
    };
    OverlayTrigger.prototype.render = function () {
        var trigger = React.Children.only(this.props.children);
        var triggerProps = trigger.props;
        var props = {
            'aria-describedby': this.props.overlay.props.id
        };
        // create in render otherwise owner is lost...
        this._overlay = this.getOverlay();
        props.onClick = create_chained_function_1.default(triggerProps.onClick, this.props.onClick);
        if (isOneOf('click', this.props.trigger)) {
            props.onClick = create_chained_function_1.default(this.toggle, props.onClick);
        }
        if (isOneOf('hover', this.props.trigger)) {
            warning_1.default(!(this.props.trigger === 'hover'), '[adp-react-components] Specifying only the `"hover"` trigger limits the visibilty of the overlay to just mouse users. ' +
                'Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.');
            props.onMouseOver = create_chained_function_1.default(this.handleMouseOver, this.props.onMouseOver, triggerProps.onMouseOver);
            props.onMouseOut = create_chained_function_1.default(this.handleMouseOut, this.props.onMouseOut, triggerProps.onMouseOut);
        }
        if (isOneOf('focus', this.props.trigger)) {
            props.onFocus = create_chained_function_1.default(this.handleDelayedShow, this.props.onFocus, triggerProps.onFocus);
            props.onBlur = create_chained_function_1.default(this.handleDelayedHide, this.props.onBlur, triggerProps.onBlur);
        }
        return React.cloneElement(trigger, props);
    };
    OverlayTrigger.propTypes = Object.assign({}, overlay_1.Overlay.propTypes, {
        /**
         * Specify which action or actions trigger Overlay visibility
         */
        trigger: PropTypes.oneOfType([
            PropTypes.oneOf(['click', 'hover', 'focus']),
            PropTypes.arrayOf(PropTypes.oneOf(['click', 'hover', 'focus']))
        ]),
        /**
         * A millisecond delay amount to show and hide the Overlay once triggered
         */
        delay: PropTypes.number,
        /**
         * A millisecond delay amount before showing the Overlay once triggered.
         */
        delayShow: PropTypes.number,
        /**
         * A millisecond delay amount before hiding the Overlay once triggered.
         */
        delayHide: PropTypes.number,
        /**
         * The initial visibility state of the Overlay, for more nuanced visibility controll consider
         * using the Overlay component directly.
         */
        defaultOverlayShown: PropTypes.bool,
        /**
         * An element or text to overlay next to the target.
         */
        overlay: PropTypes.node.isRequired,
        /**
         * @private
         */
        onBlur: PropTypes.func,
        /**
         * @private
         */
        onClick: PropTypes.func,
        /**
         * @private
         */
        onFocus: PropTypes.func,
        /**
         * @private
         */
        onMouseEnter: PropTypes.func,
        /**
         * @private
         */
        onMouseLeave: PropTypes.func,
        onMouseOver: PropTypes.func,
        onMouseOut: PropTypes.func,
        onToggle: PropTypes.func,
        // override specific overlay props
        /**
         * @private
         */
        target: function () { },
        /**
         * @private
         */
        onHide: function () { },
        /**
         * @private
         */
        show: function () { },
        hideOnWindowResize: PropTypes.bool
    });
    OverlayTrigger.defaultProps = {
        trigger: ['hover', 'focus'],
        overlay: '',
        hideOnWindowResize: false
    };
    return OverlayTrigger;
}(React.Component));
exports.OverlayTrigger = OverlayTrigger;
